import { create } from "zustand";
import {toast} from "react-toastify";
import { useI18nStore } from "./i18n.store";

const defaultSelectedColumns = [
    "deal_id",
    "specification",
    "project_name",
    "vendor",
    "close_date",
    "expiration_date",
    "total_amount_currency",
    "sales_person",
    "end_customer",
    "deal_state"
];

export const useDealsTableStore = create((set, get) => {
    return {
        selectedColumns: [...defaultSelectedColumns],
        getAvailableColumns: () => {
            const t = useI18nStore.getState().t;
            return {
                "deal_id": t("deals.registration"),
                "project_name": t("deals.projectName"),
                "specification": t("deals.deviceSpec"),
                "vendor": t("deals.vendor"),
                "sales_person": t("deals.salesperson"),
                "end_customer": t("opportunities.endCustomer"),
                "close_date": t("deals.expectedCloseDate"),
                "expiration_date": t("deals.expirationDate"),
                "registration_date": t("deals.registrationDate"),
                "deal_state": t("common.state"),
            };
        },
        toggleColumn: (key) => {
            const t = useI18nStore.getState().t;
            if (!get().selectedColumns.includes(key)) {
                /*if (get().selectedColumns.length >= 7) {
                    toast.error(t("users.cannotSelectMoreColumns"));
                    return;
                }*/
            }
            set((state) => ({
                selectedColumns: state.selectedColumns.includes(key)
                    ? state.selectedColumns.filter((col) => col !== key)
                    : [...state.selectedColumns, key],
            }))
        },
    };
});